export default {
  NETWORK_OK: 'NETWORK_OK',
  NETWORK_FAILURE: 'NETWORK_FAILURE',
};
